import { AudioScreen } from "./Audio/AudioScreen";
import { ControlsScreen } from "./Controls/ControlsScreen";
import { VideoScreen } from "./Video/VideoScreen";
export function SettingsScreens() {
    AudioScreen();
    ControlsScreen();
    VideoScreen();
}
